import { render, staticRenderFns } from "./BaseWindowList.vue?vue&type=template&id=276e59c0"
import script from "./BaseWindowList.vue?vue&type=script&lang=js"
export * from "./BaseWindowList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports